import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "webinar_card_icon_assets",
  "use": "webinar_card_icon_assets-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"webinar_card_icon_assets\"><path d=\"m10.677 13.435-.177-.106-.177.106-4.976 2.955V4.556c0-.66.549-1.209 1.224-1.209h7.858c.675 0 1.224.548 1.224 1.209V16.39l-4.976-2.955Z\" fill=\"#2C2D2E\" stroke=\"#2C2D2E\" stroke-width=\".694\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol